import React from 'react'
import EmailAppContainer from '../../../../Components/Apps/Email/EmailApplication'

export default function EmailApplication() {
  return (
    <div className='page-body'>
        <EmailAppContainer/>
    </div>
  )
}
